import { useEffect, useState } from "react";
import { api, assetUrl } from "@/lib/api";

function PageHeader({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative overflow-hidden border-b border-border bg-secondary/40">
      <div className="container-xl grid items-center gap-8 py-14 md:py-20 lg:grid-cols-2">
        <div>
          <span className="eyebrow text-accent">{eyebrow}</span>
          <h1 className="mt-3 text-4xl font-700 sm:text-5xl">{title}</h1>
          {subtitle && <p className="mt-5 max-w-xl text-lg text-muted-foreground">{subtitle}</p>}
        </div>
        {image && (
          <div className="mx-auto w-full max-w-[420px] overflow-hidden rounded-[2rem] shadow-xl ring-1 ring-border">
            <img src={image} alt={title} className="h-[450px] w-full object-cover" />
          </div>
        )}
      </div>
    </section>
  );
}

export default function AboutUs() {
  const [c, setC] = useState(null);
  useEffect(() => {
    api.get("/content/about_us").then(({ data }) => setC(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="about-us-page">
      <PageHeader
        eyebrow="About Us"
        title={c?.heading || "About Eco Homeo (EHP)"}
        subtitle={c?.intro}
        image={assetUrl(c?.image) || "https://images.unsplash.com/photo-1758525732480-8df43412b54c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"}
      />
      <section className="section-pad">
        <div className="container-xl grid gap-8 md:grid-cols-2">
          {(c?.sections || []).map((s, i) => (
            <div key={i} className="rounded-2xl border border-border bg-card p-8 transition hover:shadow-lg animate-fade-up" style={{ animationDelay: `${i * 80}ms` }} data-testid={`about-us-section-${i}`}>
              <h2 className="font-serif text-2xl text-[var(--brand-navy)]">{s.title}</h2>
              <p className="mt-4 leading-relaxed text-muted-foreground">{s.body}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
